import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  Autocomplete,
  Button,
  Divider,
  InputBase,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import { PrincipalLayouts } from "../../layouts/PrincipalLayouts";
import { useForm } from "../../hooks";
import { NumberInput } from "../components/NumberInput";
import { createReservation, editReservation } from "../helpers/reservation.js";
import { useNavigate } from "react-router-dom";
import { unSelectOpportunity } from "../../store/opportunity/opportunitySlice";

export const Reservation = ({
  myCompaniesList,
  actualReservation,
  dataToAction,
  setRefetch
}) => {
  const { t } = useTranslation("global");
  const dispatch = useDispatch();
  const { avatar, investmentType } = useSelector(
    (state) => state.auth
  );

  const myName = avatar.split("-")[0] + " " + avatar.split("-")[1];
  const navigate = useNavigate();
  const [isWaiting, setIsWaiting] = useState(false);

  let formData = {
    intention: "Si",
    amount: 0,
    whoInvests: myName,
    comments: "",
    opportunityId: dataToAction.id,
    vehicle: dataToAction.vehicle,
    isInApp: dataToAction.isInApp
  };
  if (actualReservation) {
    const response =
      actualReservation?.intention === "No reserva" ? "No" : "Si";
    const { id, ...rest } = actualReservation;
    formData = { ...rest, intention: response, isInApp: dataToAction.isInApp };
  }

  const [formValues, handleInputChange, reset] = useForm(formData);

  const { intention, amount, whoInvests, comments } = formValues;

  const handleConfirm = async (e) => {
    e.preventDefault();
    setIsWaiting(true);
    const intentionBBDD =
      intention === "Si" ? "Reserva realizada" : "No reserva";

    if (
      dataToAction.myStatus === "Sin respuesta" ||
      dataToAction.myStatus === "Pending answer"
    ) {
      setRefetch((prevValue) => !prevValue);
      createReservation(
        { ...formValues, intention: intentionBBDD },
        t("reservation.successMsgAdd"),
        t("reservation.errorMsg"),
        dispatch
      );
    } else {
      editReservation(
        { ...formValues, intention: intentionBBDD },
        t("reservation.successMsgEdit"),
        t("reservation.errorMsg"),
        dispatch,
        navigate
      );
    }
    setIsWaiting(false);
    reset();
    navigate("/opportunities");
  };
  const handleCancel = () => {
    reset();
    dispatch(unSelectOpportunity());
    navigate("/opportunities");
  };

  return (
    <PrincipalLayouts>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography color="primary" variant="h5">
          {t("reservation.addTitle")}
          {dataToAction.startup}
        </Typography>
      </Stack>
      <Divider sx={{ marginTop: 2, marginBottom: 3 }} />

      <form onSubmit={handleConfirm}>
        <Stack width="100%" gap={2}>
          <Stack direction="column" width="100%" gap={0}>
            <Typography variant="overline" color="secondary">
              {t("reservation.intention")}
            </Typography>
            <Select
              name="intention"
              value={intention}
              onChange={handleInputChange}
            >
              <MenuItem value="Si">Si</MenuItem>
              <MenuItem value="No">No</MenuItem>
            </Select>
          </Stack>
          {intention === "Si" && (
            <>
              <Stack direction="column" width="100%" gap={0}>
                <Typography variant="overline" color="secondary">
                  {t("reservation.whoInvests")}
                </Typography>
                <Autocomplete
                  disablePortal
                  options={[...myCompaniesList, myName]}
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      name="whoInvests"
                    />
                  )}
                  value={whoInvests}
                  onSelect={handleInputChange}
                  fullWidth
                  required
                />
              </Stack>

              <Stack width="100%">
                <NumberInput
                  name={amount}
                  title="amount"
                  handleInputChange={handleInputChange}
                  required={true}
                  min={investmentType === "Club Partner" ? 2000 : 5000}
                />
              </Stack>

              <Stack width="100%">
                <Typography variant="overline" color="secondary">
                  {t("addevent.comments")}
                </Typography>
                <InputBase
                  fullWidth
                  name="comments"
                  size="small"
                  variant="standard"
                  value={comments}
                  onChange={handleInputChange}
                  type="text"
                  multiline
                />
              </Stack>
            </>
          )}
        </Stack>

        <Stack direction="row" justifyContent="end" gap={2} marginTop={3}>
          <Button
            sx={{ width: "140px" }}
            color="secondary"
            onClick={handleCancel}
            variant="outlined"
          >
            {t("myprofile.cancelButton")}
          </Button>
          <Button
            disabled={isWaiting}
            sx={{ width: "140px" }}
            type="submit"
            variant="contained"
          >
            {t("myprofile.confirmButton")}
          </Button>
        </Stack>
      </form>
    </PrincipalLayouts>
  );
};
